/**
 * Shared Butter Websites design system primitives.
 *
 * Buttons are pills with a 2px ink border and a hard sticker shadow, and they
 * travel 2px into that shadow on press (.bw-press) -- the system's defining
 * interaction.
 */

export const CONTACT_URL = 'https://butterwebsites.fillout.com/t/458UaaCEkEus';
export const BOOKING_URL = 'https://cal.com/butter/intro';

const buttonCommon =
  'bw-press inline-flex items-center justify-center gap-2 rounded-full border-2 border-bw-ink font-display font-bold uppercase leading-none tracking-wide shadow-sticker focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-bw-ink focus-visible:ring-offset-2';

export const buttonBase = `${buttonCommon} px-7 py-3.5 text-[15px]`;
export const buttonSm = `${buttonCommon} px-5 py-2.5 text-[13px] shadow-sticker-sm`;
